module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai32-790f0bf97346685303fa51ae03a10993.jpg";